import mapSliceToComponent from '~/imports/universal_page'
import { PAGE } from '~/lib/fetch-links'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import SliceManager from '~/components/Abstracts/SliceManager'
import { PageViewAnalytics } from '~/components/PageViewAnalytics'

import {
  getStaticPathsFunction,
  getStaticPropsFunction,
} from '~/data/page-data'
import { DefaultPageData } from '~/data/page-data/serializer'

import css from './styles.module.scss'

function Universal({ slices }: DefaultPageData) {
  return (
    <section className={css.UniversalPage}>
      <SliceManager
        mapSliceTypeToComponent={mapSliceToComponent}
        slicesData={slices}
      />
      <PageViewAnalytics template="page" />
    </section>
  )
}

export default Universal

export const getStaticProps = getStaticPropsFunction({
  type: STORYBLOK_TYPES.UNIVERSAL,
  fetchLinks: PAGE,
})

export const getStaticPaths = getStaticPathsFunction({
  type: STORYBLOK_TYPES.UNIVERSAL,
})
